// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3Jgcm","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__d0P6v"};